import React, { useState, useEffect } from "react";
import PricingCard from "../../Components/Cards/PricingCard";
import LanguageSelector from "../../Components/LanguageSelector/LanguageSelector";
import {
  Container,
  ContentDiv,
  Heading,
  MainDiv,
  PlansDiv,
  SubHeading,
  TextDiv,
  LogoutBtn,
  Banner,
  LanguageSwitcher,
} from "./style";
import { useNavigate } from "react-router-dom";
import AlertIcon from "../../assets/alert.svg";
import { useTranslation } from "react-i18next";
import { MenuItem, Select, FormControl, Menu, Avatar, IconButton } from "@mui/material";
import { Switch, Chip } from "@mui/material";


export default function Payment() {
  const [isTrialStarted, setIsTrialStarted] = useState(false);
  const [showHeaderElements, setShowHeaderElements] = useState(false);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [billingCycle, setBillingCycle] = useState("monthly");
  const [selectedPlan, setSelectedPlan] = useState("advanced"); // Default to advanced plan
  const [anchorEl, setAnchorEl] = useState(null);
  const [userName, setUserName] = useState("");
  const open = Boolean(anchorEl);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };


  const PLANS = [
    {
      key: "essential",
      titleKey: "payment.plans.essential.title",
      prices: {
        monthly: 35,
        yearly: 357,
      },
    },
    {
      key: "advanced",
      titleKey: "payment.plans.advanced.title",
      prices: {
        monthly: 59,
        yearly: 600,
      },
      popular: true,
    },
    {
      key: "business",
      titleKey: "payment.plans.business.title",
      prices: {
        monthly: 149,
        yearly: 1520,
      },
    },
  ];


  const getYearlyLabel = (monthly, yearly) => {
    const yearlyMonthlyEquivalent = monthly * 12;
    const savings = yearlyMonthlyEquivalent - yearly;

    return savings > 0
      ? `Save €${savings} per year`
      : "Yearly billing";
  };



  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("language", lng);
  };

  useEffect(() => {
    const storedTrialStatus = localStorage.getItem("isTrialStarted");
    const isSubscribed = localStorage.getItem("isSubscribed");
    const trialExpiryDate = localStorage.getItem("trialExpiryDate");
    const trialStatus =
      storedTrialStatus === null ? true : storedTrialStatus === "true";
    setIsTrialStarted(trialStatus);

    if (isSubscribed === "false") {
      if (!trialExpiryDate || new Date(trialExpiryDate) < new Date()) {
        setShowHeaderElements(true);
      }
    }

    const storedName = localStorage.getItem("name");
    if (storedName) {
      setUserName(storedName);
    }
  }, []);

  const handleTrialStart = () => {
    setIsTrialStarted(true);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  const handlePlanSelect = (planKey) => {
    setSelectedPlan(planKey);
  };

  return (
    <>
      <Container style={{ height: "100vh" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            margin: "0.5rem 1rem",
          }}
        >
          <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
            <LanguageSelector />

            <IconButton onClick={handleMenuClick} size="small">
              <Avatar
                style={{
                  width: "2.5rem",
                  height: "2.5rem",
                  backgroundColor: "#51307F",
                  color: "#FFF",
                  fontWeight: "700",
                  fontSize: "1.25rem",
                }}
              >
                {userName ? userName.charAt(0).toUpperCase() : "U"}
              </Avatar>
            </IconButton>

            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleMenuClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
            >
              <MenuItem
                onClick={() => {
                  handleMenuClose();
                  handleLogout();
                }}
                style={{ fontFamily: 'Poppins', fontSize: '0.875rem', color: '#FF4D4F' }}
              >
                {t("payment.logout")}
              </MenuItem>
            </Menu>
          </div>
        </div>
        {showHeaderElements && (
          <Banner>
            <img src={AlertIcon} alt="alert" />
            <p>{t("payment.freeTrialExpired")}</p>
          </Banner>
        )}
        <MainDiv>
          <ContentDiv>
            <TextDiv style={{ width: "80%", alignItems: "center" }}>
              <Heading style={{ textAlign: "center" }}>
                {t("payment.title")}
              </Heading>
              <SubHeading style={{ textAlign: "center" }}>
                {t("payment.description")}
              </SubHeading>
              <SubHeading style={{ textAlign: "center", marginTop: "1rem" }}>
                {t("payment.choosePlan")}
              </SubHeading>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "0.75rem",
                  marginTop: "1.5rem",
                }}
              >
                <span style={{ fontWeight: 600 }}>{t("payment.monthly")}</span>

                <Switch
                  checked={billingCycle === "yearly"}
                  onChange={(e) =>
                    setBillingCycle(e.target.checked ? "yearly" : "monthly")
                  }
                  sx={{
                    "& .MuiSwitch-switchBase.Mui-checked": {
                      color: "#51307F",
                    },
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: "#51307F",
                    },
                    "& .MuiSwitch-track": {
                      backgroundColor: "#CBD5E1",
                      opacity: 1,
                    },
                  }}
                />


                <span style={{ fontWeight: 600 }}>{t("payment.yearly")}</span>

                <Chip
                  label={t("payment.discount")}
                  size="small"
                  sx={{
                    backgroundColor: "#DCFCE7",
                    color: "#166534",
                    fontWeight: 600,
                    fontSize: "0.75rem",
                  }}
                />
              </div>

            </TextDiv>
            <PlansDiv>
              {PLANS.map((plan) => {
                const price =
                  billingCycle === "monthly"
                    ? plan.prices.monthly
                    : plan.prices.yearly;

                return (
                  <PricingCard
                    key={plan.key}
                    planKey={plan.key}
                    planType={plan.key}
                    title={t(plan.titleKey)}
                    price={price.toString()}
                    bgColor="#51307F"
                    mode={billingCycle}
                    textColor="#ffffff"
                    buttonColor="#ffffff"
                    buttonTextColor="#51307F"
                    status={
                      billingCycle === "yearly"
                        ? getYearlyLabel(plan.prices.monthly, plan.prices.yearly)
                        : t("payment.plans.advanced.status")
                    }
                    feature1={t(`payment.plans.${plan.key}.feature1`)}
                    feature2={t(`payment.plans.${plan.key}.feature2`)}
                    feature3={t(`payment.plans.${plan.key}.feature3`)}
                    feature4={t(`payment.plans.${plan.key}.feature4`)}
                    feature5={t(`payment.plans.${plan.key}.feature5`)}
                    feature6={t("payment.access")}
                    highlight={plan.popular}
                    isSelected={selectedPlan === plan.key}
                    onSelect={() => handlePlanSelect(plan.key)}
                    onTrialStart={handleTrialStart}
                  />
                );
              })}
            </PlansDiv>
          </ContentDiv>
        </MainDiv>
      </Container>
    </>
  );
}